// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ReleaseNoteReactResponse

import { hydrateReleaseNoteReactions, type ReleaseNoteReactions, type ReleaseNoteReactionsApiResponse } from './releaseNoteReactions.gen';

export type ReleaseNoteReactApiResponse = {
	success: boolean;
	reactions: ReleaseNoteReactionsApiResponse | null;
	userReaction: string | null;
};

export type ReleaseNoteReact = {
	success: boolean;
	reactions: ReleaseNoteReactions | null;
	userReaction: string | null;
};

export function hydrateReleaseNoteReact(data: ReleaseNoteReactApiResponse): ReleaseNoteReact {
	return {
		...data,
		reactions: data.reactions ? hydrateReleaseNoteReactions(data.reactions) : null,
	};
}